export default function (timestamp, showTime = false) {
  const setStamp = Math.floor(+timestamp * 1000);
  const setDate = new Date(setStamp);
  // const year = setDate.getFullYear();
  const month = (setDate.getMonth() + 1).toString().padStart(2, "0");
  const date = setDate.getDate().toString().padStart(2, "0");

  const dayWeeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  const day = dayWeeks[setDate.getDay()];

  const hours = setDate.getHours().toString().padStart(2, "0");
  const minutes = setDate.getMinutes().toString().padStart(2, "0");
  const fullDate = showTime ? `${hours}:${minutes}` : `${month}月${date}日（${day}）${hours}:${minutes}`;
  return fullDate;
}